import { render, staticRenderFns } from "./Custom_Modal.vue?vue&type=template&id=ad4ba1bc&scoped=true"
import script from "./Custom_Modal.vue?vue&type=script&lang=js"
export * from "./Custom_Modal.vue?vue&type=script&lang=js"
import style0 from "./Custom_Modal.vue?vue&type=style&index=0&id=ad4ba1bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4ba1bc",
  null
  
)

export default component.exports